/**
 * Applies the key of each value as a property named by keyName.
 * @example
 * // To use a key other than key and have TypeScript recognize it:
 * const obj = { a: { value: 1 }, b: { value: 2 } };
 * const withKey = applyKey<typeof obj, { candy: string }>(obj, 'candy');
 */
export function applyKey<T extends object, K extends string, O extends Record<PropertyKey, T>>(obj: O, keyName: K) {
  return Object.entries(obj)
    .reduce(
      (result, [key, value]) =>
        ({ ...result, [key]: { [keyName]: key, ...value } }),
      {} as Record<keyof O, T & { [key in K]: string }>
    );
}